<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-poll-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 6a2 2 0 012-2h8a2 2 0 012 2v34h2V18a2 2 0 012-2h7a2 2 0 012 2v22h1a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2a1 1 0 011-1h1V23a2 2 0 012-2h7a2 2 0 012 2v17h2V6z"/></svg>
</template>
<script>

export default {
  name: 'IconPollFill',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
